export const questionTypes = {
  text: "text",
  choice: 'choice',
  address: 'address',
};
